{
  "login": {
    "title": "Войти",
    "emailLabel": "Адрес электронной почты",
    "passwordLabel": "Пароль",
    "rememberMe": "Запомнить меня на 30 дней",
    "submitButton": "Войти",
    "submittingButton": "Вход...",
    "forgotPassword": "Забыли пароль?",
    "setNewPassword": "Установить новый пароль здесь",
    "sessionExpired": "Сессия истекла",
    "noAccountYet": "Ещё нет аккаунта?",
    "createOne": "Создать аккаунт"
  },
  "forgotPassword": {
    "title": "Забыли пароль",
    "emailLabel": "Адрес электронной почты",
    "submitButton": "Отправить ссылку для сброса пароля на email",
    "backToLogin": "Вернуться к входу",
    "submittingButton": "Отправка...",
    "successTitle": "Проверьте почту",
    "successMessage": "Если аккаунт с этим адресом существует, мы отправили ссылку для сброса пароля на вашу почту."
  },
  "confirmEmail": {
    "confirming": "Подтверждаем вашу почту…",
    "successTitle": "Почта подтверждена",
    "successMessage": "Ваш адрес электронной почты подтверждён. Теперь вы можете войти в свой аккаунт.",
    "continueToLogin": "Перейти ко входу",
    "errorTitle": "Не удалось подтвердить",
    "errorMessage": "Не удалось подтвердить вашу почту. Возможно, ссылка недействительна или срок её действия истёк."
  },
  "resetPassword": {
    "title": "Сброс пароля",
    "subtitle": "Введите новый пароль ниже",
    "newPasswordLabel": "Новый пароль",
    "newPasswordPlaceholder": "Введите новый пароль",
    "confirmPasswordLabel": "Подтвердите новый пароль",
    "confirmPasswordPlaceholder": "Подтвердите новый пароль",
    "passwordsDoNotMatch": "Пароли не совпадают",
    "submitButton": "Установить новый пароль",
    "submittingButton": "Сброс пароля...",
    "invalidToken": "Недействительный токен сброса",
    "fixRequirements": "Пожалуйста, выполните требования к паролю",
    "failedReset": "Не удалось сбросить пароль"
  },
  "acceptTerms": {
    "title": "Условия использования",
    "subtitle": "Прочитайте и примите наши условия для продолжения",
    "welcomeTitle": "Добро пожаловать в Flipping Pal!",
    "welcomeBody": "Эти условия использования описывают правила и нормы для использования сайта Flipping Pal, расположенного по адресу",
    "welcomeBody2": "Получая доступ к этому сайту, мы предполагаем, что вы принимаете эти условия использования. Не продолжайте использовать Flipping Pal, если вы не согласны со всеми условиями, указанными на этой странице.",
    "keyPointsTitle": "Ключевые моменты:",
    "keyPoints": {
      "0": "Flipping Pal владеет всеми правами интеллектуальной собственности на материалы этого сайта",
      "1": "Вы не можете перепубликовывать, продавать или распространять контент Flipping Pal",
      "2": "Мы используем файлы cookie для улучшения вашего опыта на нашем сайте",
      "3": "Комментарии пользователей не отражают мнения Flipping Pal",
      "4": "Мы оставляем за собой право изменять эти условия в любое время",
      "5": "Контент сайта предоставляется \"как есть\" без гарантий"
    },
    "responsibilitiesTitle": "Ваши обязанности:",
    "responsibilities": {
      "0": "Используйте сервис в соответствии со всеми применимыми законами",
      "1": "Соблюдайте безопасность учётных данных вашего аккаунта",
      "2": "Не пытайтесь нарушить безопасность наших систем",
      "3": "Уважайте права интеллектуальной собственности"
    },
    "previewNote": "📄 Это предварительный просмотр наших Условий использования. Нажмите «Просмотреть полные условия», чтобы прочитать весь документ.",
    "viewFullTerms": "Просмотреть полные Условия использования (открывается в новой вкладке)",
    "checkboxLabel": "Я прочитал и согласен с Условиями использования",
    "checkboxDescription": "Устанавливая этот флажок, вы подтверждаете, что прочитали, поняли и соглашаетесь соблюдать эти условия.",
    "acceptButton": "Принять и продолжить",
    "acceptingButton": "Принятие...",
    "questionsText": "Вопросы о наших условиях?",
    "contactSupport": "Связаться с поддержкой"
  },
  "discord": {
    "linkingTitle": "Привязка аккаунта Discord",
    "linkingBody": "Подождите, пока мы подключаем ваш аккаунт Discord...",
    "successTitle": "Успешно!",
    "successBody": "Ваш аккаунт Discord был успешно привязан.",
    "successWindowClose": "Это окно закроется автоматически...",
    "successRedirect": "Перенаправление в настройки...",
    "errorTitle": "Привязка не удалась",
    "errorBody": "Нам не удалось привязать ваш аккаунт Discord.",
    "errorWindowClose": "Это окно закроется автоматически...",
    "errorRedirect": "Перенаправление в настройки...",
    "backToSettings": "Вернуться к настройкам"
  },
  "register": {
    "title": "Создать аккаунт",
    "subtitle": "Присоединяйтесь и начните свой путь сегодня",
    "emailLabel": "Адрес электронной почты",
    "emailPlaceholder": "Введите ваш адрес электронной почты",
    "passwordLabel": "Пароль",
    "passwordPlaceholder": "Создайте надёжный пароль",
    "confirmPasswordLabel": "Подтверждение пароля",
    "confirmPasswordPlaceholder": "Подтвердите ваш пароль",
    "passwordStrength": "Надёжность пароля",
    "strengthStrong": "Сильный",
    "strengthMedium": "Средний",
    "strengthWeak": "Слабый",
    "termsLabel": "Я согласен с",
    "termsLink": "Условиями использования",
    "termsLabel2": "",
    "submitButton": "Создать аккаунт",
    "submittingButton": "Создание аккаунта...",
    "alreadyHaveAccount": "Уже есть аккаунт?",
    "signInHere": "Войти здесь",
    "registrationClosed": "В настоящее время регистрация невозможна",
    "registrationClosedMessage": "На данный момент регистрация закрыта",
    "fixFormErrors": "Пожалуйста, исправьте ошибки в форме перед отправкой",
    "acceptTermsRequired": "Пожалуйста, примите Условия использования для продолжения",
    "registrationFailed": "Регистрация не удалась. Пожалуйста, попробуйте снова."
  },
  "errorBoundary": {
    "title": "Что-то пошло не так",
    "subtitle": "Произошла непредвиденная ошибка. Не волнуйтесь — ваши данные в безопасности.",
    "unknownError": "Неизвестная ошибка",
    "goHome": "На главную",
    "reloadPage": "Перезагрузить страницу",
    "logout": "Выйти",
    "showErrorDetails": "Показать детали ошибки",
    "hideErrorDetails": "Скрыть детали ошибки",
    "copyToClipboard": "Скопировать в буфер обмена",
    "copied": "Скопировано!",
    "copy": "Копировать",
    "errorLabel": "Ошибка",
    "componentStackLabel": "Стек компонентов",
    "reference": "Идентификатор"
  }
}
